var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coverLogo",class:{
  'coverLogo--stickyTop': _vm.stickyTop,
  'coverLogo--stickyBottom': _vm.stickyBottom
}},[_c('img',{ref:"coverImage",staticClass:"coverLogo__logoImage",class:{
      'coverLogo__logoImage--stickyTop': _vm.stickyTop,
      'coverLogo__logoImage--stickyBottom': _vm.stickyBottom
    },style:({ 'aspect-ratio': _vm.ratio }),attrs:{"src":_vm.logoImage,"alt":"Logo SL"}})])}
var staticRenderFns = []

export { render, staticRenderFns }